import React, { useState, useEffect } from 'react';
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';
import { powerbiService } from '../services/powerbiService';
import './ReportsPage.css';

const ReportsPage: React.FC = () => {
  const [embedConfig, setEmbedConfig] = useState<models.IReportEmbedConfiguration | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  // TAM Dashboard Report ID
  const REPORT_ID = '41b8b7f1-6646-4afa-a550-c1dd9ff81f63';

  useEffect(() => {
    loadReport();
  }, []);

  const loadReport = async () => {
    setLoading(true);
    setError(null);

    try {
      const config = await powerbiService.getEmbedConfig(REPORT_ID);
      setEmbedConfig(config);
    } catch (err: any) {
      console.error('Error loading report:', err);
      setError(err.message || 'Failed to load Power BI report');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="reports-page">
      <div className="reports-header">
        <h1 className="reports-title neuro-styrene-bold">TAM Dashboard</h1>
        <p className="reports-subtitle neuro-silkafont-regular">
          Explore your interactive Power BI TAM dashboard and analytics
        </p>
      </div>

      <div className="reports-content">
        {loading && (
          <div className="reports-loading">
            <div className="loading-spinner"></div>
            <p className="loading-text neuro-silkafont-regular">Loading report...</p>
          </div>
        )}

        {error && (
          <div className="reports-error">
            <div className="error-icon">⚠️</div>
            <h3 className="error-title neuro-styrene-bold">Unable to Load Report</h3>
            <p className="error-message neuro-silkafont-regular">{error}</p>
            <button onClick={loadReport} className="btn-primary">
              Try Again
            </button>
          </div>
        )}

        {!loading && !error && embedConfig && (
          <div className="reports-embed-container">
            <PowerBIEmbed
              embedConfig={embedConfig}
              cssClassName="reports-embed"
              getEmbeddedComponent={(embeddedReport) => {
                // Store the embedded report instance if needed
                console.log('Report loaded:', embeddedReport);
              }}
            />
          </div>
        )}
      </div>

    </div>
  );
};

export default ReportsPage;
